import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        configuration: {},
        touring: true,
        travelling: false,
        tourStep: -1,
        previousTourStep: null,
        incrementDecrementButton: false,
    },

    getters: {
        configuration: state => {
            return state.configuration
        },
        touring: state => {
            return state.touring
        },
        travelling: state => {
            return state.travelling
        },
        hasPreviousStep: state => {
            return state.tourStep > 0
        },
        hasNextStep: state => {
            return (state.tourStep < (state.configuration.steps.length - 1))
        },
        tourStep: state => {
            return state.tourStep
        },
        previousTourStep: state => {
            return state.previousTourStep
        },
        incrementDecrementButton: state => {
            return state.incrementDecrementButton
        },
    },

    actions: {
        setConfiguration: ({ commit }, payload) => {
            commit('setConfiguration', payload)
        },
        setTravelling: ({ commit }, payload) => {
            commit('setTravelling', payload)
        },
        setTouring: ({ commit }, payload) => {
            commit('setTouring', payload)
        },
        setTourStep: ({ commit }, payload) => {
            commit('setTourStep', payload)
        },
        setIncrementDecrementButton: ({ commit }, payload) => {
            commit('setIncrementDecrementButton', payload)
        },
        incrementTourStep: ({ commit, getters }) => {
            if (getters.hasNextStep) {
                commit('setIncrementDecrementButton', true)
                commit('setTravelling', true)
                commit('incrementTourStep')
            }
        },
        decrementTourStep: ({ commit, getters }) => {
            if (getters.hasPreviousStep) {
                commit('setIncrementDecrementButton', true)
                commit('decrementTourStep')
            }
        },
    },
    
    mutations: {
        setConfiguration: (state, payload) => {
            state.configuration = payload
        },
        setTravelling: (state, payload) => {
            state.travelling = payload
        },
        setTouring: (state, payload) => {
            state.touring = payload
        },
        setTourStep: (state, payload) => {
            state.previousTourStep = state.tourStep
            state.tourStep = payload
        },
        setIncrementDecrementButton: (state, payload) => {
            state.incrementDecrementButton = payload
        },
        incrementTourStep: state => {
            state.previousTourStep = state.tourStep
            state.tourStep++
        },
        decrementTourStep: state => {
            state.previousTourStep = state.tourStep
            state.tourStep--
        },
    },
})
